import React from "react";

interface BaseAlertProps {
  type?: "info" | "success" | "warning" | "error";
  message: string;
  onClose?: () => void;
}

const BaseAlert: React.FC<BaseAlertProps> = ({ type = "info", message, onClose }) => {
  if (!message) return null;

  return (
    <div className={`base-alert ${type}`}>
      <span className="base-alert-message">{message}</span>
      {onClose && (
        <button className="base-alert-close" onClick={onClose}>
          ×
        </button>
      )}
    </div>
  );
};

export default BaseAlert;
